import { useAccount } from './useAccount';

// Keep this list in sync with services/teacher/refactor/utils/isShowbieEmail.ts.
const showEmailDomains = ['@showbie.com', '@showbie.com@showbie-email'];

/**
 * Use this query to check if the current user has a Showbie email address. Applies to both Socrative and Showbie accounts.
 */
export function useIsShowbieAccount() {
  const showbieAccountQuery = useAccount({
    select: (account) =>
      showEmailDomains.some((domain) => account.email.endsWith(domain)),
  });

  return { ...showbieAccountQuery, isShowbieAccount: showbieAccountQuery.data };
}
